import {
  StatusBar,
  View,
  Text,
  Pressable,
  TouchableOpacity,
} from "react-native";
import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

import {
  updateData,
  updateDataImage,
} from "../../../../services/Profile/profileService";
import styles from "../../styles/profileStyle";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import { Colors } from "../../../../globalStyles/ColorConfig";
import CompositeDropdown from "../../components/DropDown";
import RadioView from "../../components/RadioView";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import { PROFILE_ROUTES } from "../../../../navigation/routes";

const ViewComponent = ({
  title,
  icon,
  isSelected,
  onSelectView,
}: {
  title?: any;
  icon?: any;
  isSelected?: any;
  onSelectView?: any;
}) => {
  return (
    <View
      style={{
        height: 130,
        width: "48%",
        overflow: "hidden",
        borderRadius: 12,
        borderWidth: 2,
        borderColor: isSelected ? Colors.gold10 : "transparent",
        marginBottom: 10,
      }}
    >
      <Pressable
        onPress={() => onSelectView(title)}
        style={{
          backgroundColor: isSelected ? "#FFF" : "#F8F8F8",
          width: "100%",
          height: "100%",
          justifyContent: "space-between",
          padding: 20,
        }}
        android_ripple={{ color: "#D2D2D2", borderless: false }}
      >
        <Text style={[GlobalStyles.bodyText, { marginRight: 10 }]}>{icon}</Text>
        <Text
          style={[
            GlobalStyles.ctaText,
            {
              color: Colors.black40,
              fontSize: 16,
              fontFamily: "InterSemiBold",
              letterSpacing: -0.4,
            },
          ]}
          numberOfLines={2}
        >
          {title}
        </Text>
      </Pressable>
    </View>
  );
};

const CityAdd = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [reason, setReason] = useState<string | null>(null);
  const [selectedOption, setSelectedOption] = useState<string | null | any>(
    null
  );

  const options = ["Bangkok"];

  const handleSelect = (option: any) => {
    setSelectedOption(option);
  };

  const handleNextButton = async () => {
    const updateUser = {
      userInfo: {
        reasonForStayingInCity: reason,
        location: selectedOption,
      },
    };
    await updateDataImage(updateUser);
    await updateData({ steps: 8 });
    navigation.navigate(PROFILE_ROUTES.USE_REASON as never);
  };

  const validateName = () => {
    if (selectedOption?.length < 1 || !reason) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 25,
          gap: 16,
        }}
      >
        <View
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "18%", backgroundColor: "black" }}></View>
          <View style={{ width: "50%" }}>
            <TopIconView
              icon={<OnBoardingIcons.LocationIcon />}
              currentScreen={8}
              totalScreens={10}
            />
          </View>
          <TouchableOpacity
            onPress={() =>
              navigation.navigate(PROFILE_ROUTES.USE_REASON as never)
            }
          >
            <Text
              style={{
                color: "#C0A46F",
                textDecorationLine: "underline",
                fontSize: 15,
              }}
            >
              Skip
            </Text>
          </TouchableOpacity>
        </View>
        <View style={styles.middleScreen}>
          <TextView
            title="Which city are you based in?"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                color: "rgba(0,0,0,0.9)",
                lineHeight: 37,
                letterSpacing: -0.3,
                marginBottom: 10,
              },
            ]}
          />
          <View style={{ zIndex: 22 }}>
            <CompositeDropdown options={options} onSelect={handleSelect} />
          </View>
          {selectedOption?.length > 0 && (
            <>
              <TextView
                title={`Whats bring you to ${selectedOption}?`}
                textStyle={[
                  GlobalStyles.heading3,
                  {
                    fontFamily: "EBGaramondSemiBold",
                    fontSize: 25,
                    color: "rgba(0,0,0,0.7)",
                    lineHeight: 37,
                    letterSpacing: -0.3,
                    marginTop: 30,
                  },
                ]}
              />
              <View style={styles.optionBox}>
                <RadioView
                  wrap={true}
                  select={setReason}
                  style={{
                    paddingTop: 10,
                    paddingRight: 30,
                  }}
                >
                  <ViewComponent
                    title="I live here"
                    icon={<OnBoardingIcons.HomeIcon />}
                  />
                  <ViewComponent
                    title="I am here for work"
                    icon={<OnBoardingIcons.SuitcaseIcon />}
                  />
                  <ViewComponent
                    title="I am here for vacation"
                    icon={<OnBoardingIcons.UmbrellaIcon />}
                  />
                  <ViewComponent
                    title="Prefer not to say"
                    icon={<OnBoardingIcons.DisableIcon />}
                  />
                </RadioView>
              </View>
            </>
          )}
        </View>
      </View>

      <BottomView
        enableTitle={true}
        onPress={handleNextButton}
        disableBtn={validateName()}
        bottomTitle="This helps our engine to understand you better"
        style={{ paddingBottom: 20 }}
      />
    </SafeAreaView>
  );
};

export default CityAdd;
